import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "row mb-4" }
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_download_excel = _resolveComponent("download-excel")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DrawerFichaProfesional = _resolveComponent("DrawerFichaProfesional")!
  const _component_AsignarProfesionalModal = _resolveComponent("AsignarProfesionalModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("tabla.serviciosProfesionalesListado.titulo")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_download_excel, {
            data: _ctx.profesionalesListado,
            labels: _ctx.csvLabels,
            fields: _ctx.csvFields,
            name: _ctx.csvName
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_6, [
                _createElementVNode("i", {
                  class: "fas fa-file-excel fs-3",
                  title: _ctx.$t('tabla.serviciosProfesionalesListado.boton.imprimir')
                }, null, 8, _hoisted_7)
              ])
            ]),
            _: 1
          }, 8, ["data", "labels", "fields", "name"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.busqueda,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.busqueda) = $event)),
              type: "text",
              placeholder: 
              _ctx.$t('tabla.serviciosProfesionalesListado.buscar.placeholder')
            ,
              clearable: ""
            }, {
              prefix: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createVNode(_component_el_table, {
          data: _ctx.profesionalesFiltrados,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('tabla.serviciosProfesionalesListado.cabecera.nombre'),
              sortable: "",
              "sort-method": _ctx.sortNombreApellidos,
              "min-width": "150"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.nombre + " " + scope.row.apellidos), 1)
              ]),
              _: 1
            }, 8, ["label", "sort-method"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('tabla.serviciosProfesionalesListado.cabecera.telefono'),
              prop: "telefono",
              sortable: "",
              width: "120"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('tabla.serviciosProfesionalesListado.cabecera.email'),
              prop: "email",
              sortable: "",
              "min-width": "150"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('tabla.serviciosProfesionalesListado.cabecera.titulacion'),
              sortable: "",
              "min-width": "150"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.titulacion
                .map((t) => _ctx.titulacionesTodas.filter((a) => a.id == t))
                ?.map((t) => t.map((r) => r.text))
                .join(", ") || ""), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              width: "120",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (_ctx.verFichaProfesional(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("tabla.serviciosProfesionalesListado.fila.ver")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "text",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_asignar_profesional",
                  onClick: ($event: any) => (_ctx.seleccionarProfesional(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("tabla.serviciosProfesionalesListado.fila.asignar")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_DrawerFichaProfesional, {
          "before-close": _ctx.drawerCerrar,
          displayFicha: _ctx.drawerFicha,
          profesional: _ctx.profesionalSeleccionado
        }, null, 8, ["before-close", "displayFicha", "profesional"])
      ])
    ]),
    _createVNode(_component_AsignarProfesionalModal, {
      profesionalSeleccionado: _ctx.profesionalSeleccionado,
      comarcaId: _ctx.comarcaId,
      servicioId: _ctx.servicioId || _ctx.token,
      fechaInicioCompleta: _ctx.fechaInicioCompleta,
      fechaFinCompleta: _ctx.fechaFinCompleta
    }, null, 8, ["profesionalSeleccionado", "comarcaId", "servicioId", "fechaInicioCompleta", "fechaFinCompleta"])
  ], 64))
}